import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  Button,
  Table,
  Space,
  Modal,
  Layout,
  Form,
  Input,
  Select,
} from "antd";
import { Link } from "react-router-dom";
import Highlighter from "react-highlight-words";
import { SearchOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { getBookings } from "../../redux/booking/action";
import { getTickets } from "../../redux/ticket/action";

const { Content } = Layout;
const { Option } = Select;

function BookingInformation() {
  const dispatch = useDispatch();
  const { bookings } = useSelector((state) => state.booking);
  const [isEditModalVisible, setEditModalVisible] = useState(false);
  const [isDeleteModalVisible, setDeleteModalVisible] = useState(false);
  const [accountModal, setAccountModal] = useState({});

  const { tickets, ticketsLoading } = useSelector((state) => state.ticket);

  useEffect(() => {
    dispatch(getTickets);
    dispatch(getBookings);
  }, [dispatch]);
  function columns(showModal) {
    return [
      {
        title: "Id",
        dataIndex: "id",
        key: "id",
      },
      {
        title: "Ticket No",
        dataIndex: "ticketNo",
        key: "ticketNo",
        ...getColumnSearchProps("ticketNo"),
      },
      {
        title: "Passengers",
        dataIndex: "passengers",
        key: "passengers",
        ...getColumnSearchProps("passengers"),
      },
      {
        title: "Seat",
        dataIndex: "seat",
        key: "seat",
        ...getColumnSearchProps("seat"),
      },
      {
        title: "Route",
        dataIndex: "route",
        key: "route",
        ...getColumnSearchProps("route"),
      },
      {
        title: "Price",
        dataIndex: "price",
        key: "price",
        ...getColumnSearchProps("price"),
      },
      {
        title: "Plate Number",
        dataIndex: "plateNumber",
        key: "plateNumber",
        ...getColumnSearchProps("plateNumber"),
      },
      {
        title: "Status",
        dataIndex: "status",
        key: "status",
        ...getColumnSearchProps("status"),
      },
      {
        title: "pickup",
        dataIndex: "pickup",
        key: "pickup",
        ...getColumnSearchProps("pickup"),
      },
      {
        title: "dropoffs",
        dataIndex: "dropoff",
        key: "dropoff",
        ...getColumnSearchProps("dropoff"),
      },
      // {
      //   title: "Action",
      //   key: "action",
      // render: (text, record) => (
      //   <Space size="middle">
      //     <Button
      //       style={{ background: "#eba134", borderColor: "#eba134" }}
      //       type="primary"
      //       shape="round"
      //       icon={<EditOutlined />}
      //       size="small"
      //       onClick={() => showModal(record)}
      //     />
      //     <Button
      //       style={{ background: "#db0925", borderColor: "#db0925" }}
      //       shape="round"
      //       type="primary"
      //       icon={<DeleteOutlined />}
      //       size="small"
      //       onClick={showModal}
      //     />
      //   </Space>
      // ),
      // },
    ];
  }
  // Handle edit modal
  const showEditModal = () => {
    setEditModalVisible(true);
  };

  const handleEditModalCancel = () => {
    setAccountModal({});
    setEditModalVisible(false);
  };

  // Handle delete modal
  const showDeleteModal = () => {
    setDeleteModalVisible(true);
  };

  const handleDeleteModalCancel = () => {
    setDeleteModalVisible(false);
  };

  // Form handle
  const onFinish = (values) => {};

  const onFinishFailed = (errorInfo) => {};

  const modalToggle = (record, rowIndex) => {
    setAccountModal(record);

    setEditModalVisible(true);
  };

  // TODO searching and sorting table functionality for Conductors page
  const [searchText, setSearchText] = useState(false);
  const [searchedColumn, setSearchedColumn] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [filteredInfo, setFilteredInfo] = useState(null);
  const [sortedInfo, setSortedInfo] = useState(null);
  let getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            setSearchInput(node);
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>

          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => setSearchInput(""), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  let handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  let handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
    setFilteredInfo(null);
    setSortedInfo(null);
  };

  // Columns data

  return (
    <div className="tabled">
      <Row gutter={[24, 0]}>
        <Col span={24}>
          <Card
            bordered={false}
            className="criclebox tablespace mb-24"
            title="Ticket Information"
          >
            <div
              style={{
                display: "flex",
                padding: "2em 2em 2em 2em",
                width: "100%",
              }}
            >
              <Table
                style={{ width: "100%" }}
                dataSource={tickets}
                columns={columns(modalToggle)}
                loading={ticketsLoading}
                scroll={{ x: 400 }}
              />
            </div>
          </Card>
        </Col>
      </Row>

      <Modal
        title="Edit Account"
        visible={isEditModalVisible}
        onCancel={handleEditModalCancel}
        footer={[
          <Button key="back" onClick={handleEditModalCancel}>
            cancel
          </Button>,
          <Button key="submit" type="primary">
            Update
          </Button>,
        ]}
        width={1000}
      >
        <Content className="p-0">
          <Form
            name="basic"
            initialValues={{ remember: true }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            layout="vertical"
            className="row-col"
          >
            <Row>
              <Col
                xs="8"
                xl={8}
                style={{
                  padding: "1em",
                }}
              >
                <Form.Item
                  className="bankName"
                  label="Bank Name"
                  name="bankName"
                  rules={[
                    {
                      required: true,
                      message: "Please input Bank name!",
                    },
                  ]}
                >
                  <Input
                    placeholder="Bank Name..."
                    defaultValue={accountModal.bankName}
                  />
                </Form.Item>
              </Col>
              <Col
                xs={8}
                xl={8}
                style={{
                  padding: "1em",
                }}
              >
                <Form.Item
                  className="accountName"
                  label="Account Name"
                  name="accountName"
                  rules={[
                    {
                      required: true,
                      message: "Please input Account Name!",
                    },
                  ]}
                >
                  <Input defaultValue={accountModal.accountName} />
                </Form.Item>
              </Col>
              <Col
                xs={8}
                xl={8}
                style={{
                  padding: "1em",
                }}
              >
                <Form.Item
                  className="accountNumber"
                  label="Account Number"
                  name="accountNumber"
                  rules={[
                    {
                      required: true,
                      message: "Please input Account Number!",
                    },
                  ]}
                >
                  <Input
                    placeholder="Account Number..."
                    defaultValue={accountModal.accountNumber}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Col
                xs="8"
                xl={8}
                style={{
                  padding: "1em",
                }}
              >
                <Form.Item
                  className="status"
                  label="Status"
                  name="status"
                  rules={[
                    {
                      required: true,
                      message: "Please input the Status!",
                    },
                  ]}
                >
                  <Select defaultValue="active">
                    <Option value="active">Active</Option>
                    <Option value="inactive">InActive</Option>
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Content>
      </Modal>

      {/*
        Delete Conductor Modal
      */}
      <Modal
        title="Delete Conductor"
        visible={isDeleteModalVisible}
        onCancel={handleDeleteModalCancel}
        footer={[
          <Button key="back" onClick={handleDeleteModalCancel}>
            cancel
          </Button>,
          <Button key="submit" danger type="primary">
            Delete
          </Button>,
        ]}
      >
        <p>Are you sure?</p>
        <p>you want to delete the following Account ?</p>
        <p>Account Name Full Name</p>
      </Modal>
    </div>
  );
}

export default BookingInformation;
